import { api } from "../api/api";
import { useApi } from "../core/hooks/useApi";
import { useConditional } from "../core/hooks/useConditional";
import { useData } from "../core/hooks/useData";
import { Modal, ModalProps } from "../core/ui/Modal";
import { Spinner } from "../core/ui/Spinner";
import { Table } from "../core/ui/Table";
import { Icon } from "../core/ui/icons";
import { expectArray } from "../core/utils/array";
import { account_resource } from "../types";


export function ResourcePicker(props: {
	prop: string,
}) {

	const data = useData();
	const value = data.getValue(props.prop);

	let selected;
	if (!value) {
		selected = <i>None selected</i>;
	} else {
		selected = (
			<div className="flex horiz gap-5">
				<Icon type="document" />
				<span>{value.title}</span>
			</div>
		)
	}

	const choose = useConditional(() => {
		return (
			<ChooseModal
				onCancel={choose.close}
				onSave={(res: account_resource) => {
					data.setValue(props.prop, {
						blob: res.id,
						title: res.title,
						ext: res.ext,
					});

					choose.close();
				}}
			/>
		);
	});
	
	return (
		<div className="resource-picker flex horiz align-center gap-5">
			{selected}

			<button 
				onClick={() => {
					choose.show({});
				}}
			>Choose</button>

			{choose.render()}
		</div>
	);
}

function ChooseModal(props: {
	onCancel: () => void,
	onSave: (something: any) => void,
}) {

	// load all available resources
	const resources = useApi({
		request: () => api.account_resource_get({}),
		prepareResult: (result) => {
			return expectArray(result);
		}
	}, []);

	let items: any;

	if (!resources) {
		items = <Spinner size="small" key="spinner" />;

	} else {
		items = 
			<Table
				interactive={true}
				cols={[
					{ id: "title", title: "Name" },
					{ id: "ext", title: "Ext" },
					{ id: "sizeBytes", title: "Size (bytes)" },
				]}
				items={resources}
				render={{
					colTitle: (c) => c.title,

					colValue: (r, c) => {
						return (r as any)[c.id];
					}
				}}

				onClick={(e, r) => {
					if (r) {
						props.onSave(r);
					}
				}}
			/>		
	}

	return (
		<Modal
			title={"Choose resource"}
			size="width-50vw"
			onCancel={() => {
				props.onCancel();
			}}
			showSave={false}
		>
			{items}
		</Modal>
	)
}